import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const AlertInEmptyTriangleIcon = ({
  width = "21",
  height = "20",
  color = "#CB6D2B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 19L10.4211 1L20.8421 19H0ZM3.26842 17.1053H17.5737L10.4211 4.78947L3.26842 17.1053ZM11.0965 15.886C11.2778 15.7041 11.3684 15.4789 11.3684 15.2105C11.3684 14.9421 11.2775 14.7173 11.0956 14.536C10.9137 14.3547 10.6888 14.2638 10.4211 14.2632C10.1533 14.2625 9.92842 14.3535 9.74653 14.536C9.56463 14.7185 9.47368 14.9434 9.47368 15.2105C9.47368 15.4777 9.56463 15.7028 9.74653 15.886C9.92842 16.0692 10.1533 16.1598 10.4211 16.1579C10.6888 16.156 10.914 16.066 11.0965 15.886ZM9.47368 13.3158H11.3684V8.57895H9.47368V13.3158Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
